export const sitePlans = {
    basic: { monthly: "$15", annual: "$12.50" },
    standard: { monthly: "$30", annual: "$25" },
    premium: { monthly: "$60", annual: "$50" },
};

export const siteContact = {
    phone: "+1-800-769-8174",
    supportEmail: "support@ezclocker.com",
    salesEmail: "info@ezclocker.com"
};

export const siteFaqs = [
    {
        id: 'panel1',
        question: "How does the 30 day free trial work?",
        answer: "You can try out ezClocker for 30 days completely free. No credit card required if you are subscribing via the website and you can add as many employees as you like. Support will also be included in the free trial in case you have questions or need help getting setup."
    },
    {
        id: 'panel2',
        question: "Do I have to install anything?",
        answer: "Our software is cloud-based so there is nothing to install. Simply create an account, add employees and let them clock in/out. You have access to your data using any device: computer, iPad, iPhone, or Android."
    },
    {
        id: 'panel3',
        question: "How does the GPS feature work?",
        answer: "When employees clock in or out using ezClocker the app captures the GPS location of the employees. You as the employer can view the GPS information on your phone or computer on an easy to view map screen. Please note that ezClocker does not track the location of your employees while they are working, only when they press the clock in or clock out buttons."
    },
    {
        id: 'panel4',
        question: "How do I get started?",
        answer: "Great question, simply visit our ezClocker <a href=\"https://ezclocker.com/\"><strong>homepage</strong></a>, enter your business name, email, password and sign up. To learn more what ezClocker has to offer please watch this &nbsp;<a href=\"https://vimeo.com/1054674815/b6322233c7\"><strong>demo</strong></a>."
    }
];

export const dedicatedFaqs = [
    {
        id: 'panel1',
        question: "What is ezClocker and how does it work?",
        answer: "ezClocker is time tracking and scheduling software for small businesses available as a website or mobile application.",
        video: {
            desktop: "https://www.youtube.com/embed/Rxl_9DJARLI",
            mobile: "https://www.youtube.com/embed/j4BWohINBY4"
        }
    },
    {
        id: 'panel2',
        question: "How much does it cost and are there any hidden fees?",
        answer: "You can find our subscription plans on our pricing page <a href='/pricing'>here</a>. There are no hidden fees, what is listed is what you will pay."
    },
    {
        id: 'panel3',
        question: "Who pays for the subscription? Do my employees have to pay?",
        answer: "No, only the employer pays the monthly subscriptions. Any employees added will be covered by the employer’s payment up to the limit allowed by the subscription."
    },
    {
        id: 'panel4',
        question: "How do I pay for ezClocker?",
        answer: "You can pay for ezClocker in a few ways:<ul><li>You can sign in to your Employer account on the website, navigate to the Account page, and subscribe to a plan.</li><li>You can subscribe using your Apple iTunes account from within the ezClocker app on the iPhone.</li><li>You can subscribe using your Google Play account through the ezClocker app on your Andriod phone.</li></ul>"
    },
    {
        id: 'panel5',
        question: "Why don't I see my employees' time entries on my side when they clock in?",
        answer: "This could be caused by:<ul><li>The employee is using the wrong app, they are using ezClocker Personal when they should be using the ezClocker Business app. Or,</li><li>The employee did not accept the invite email and created their own account which is not tied to your account. Ask the employee if they accepted the invite email and followed the signup process. Or,</li><li>If you are using the app, check the date period at the top of the timesheet screen. Do the dates include the one you are trying to view?.</li></ul>"
    },
    {
        id: 'panel6',
        question: "I see my employee clocked in/out but the map says no GPS information available. What could cause this?",
        answer: "The employee could be using the wrong app, if they have an iPhone they need to use the app ezClocker Business, not ezClocker Personal."
    },
    {
        id: 'panel7',
        question: "How do I delete my account on ezClocker?",
        answer: "<ul><li> If you are an employer then sign into ezclocker.com, click the Account button and on the Account page select the Delete Account button.</li><li> If you are an employee you will not be able to delete your account. Only employers can delete employees' accounts</li></ul>"
    },
    {
        id: 'panel8',
        question: "Why do I get an access denied message when I try to sign into ezClocker?",
        answer: "<ul><li> You either entered the wrong email or password. First, try to change the password by selecting the forgot password button on the sign in page</li><li> If you don't get a reset password email in your inbox or spam folder then that means your email is not in our system. Contact support@ezclocker.com to resolve this issue. Otherwise, resetting the password should fix the problem.</li></ul>"
    },
    {
        id: 'panel9',
        question: "How do I get help for my ezClocker account?",
        answer: "You can contact ezClocker by visiting our <a href='/contact' class='contact-link'>contact page</a>."
    }
];
